import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { Navigate, useParams } from 'react-router';
import { ERoutes } from '@/types/routes';
import { useEntitiesList } from '@/providers/EntitiesListContextProvider/EntitiesListContext.hooks';
import Loader from '@/components/Loader/Loader';

export const StyledLoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  width: 100%;
`;

export const EnabledEntityRoute = ({ children }: PropsWithChildren) => {
  const { entities, isEntitiesListLoading, entitiesListError } = useEntitiesList();
  const { entityName } = useParams();

  if (isEntitiesListLoading) {
    return (
      <StyledLoaderContainer>
        <Loader />
      </StyledLoaderContainer>
    );
  }

  if (entitiesListError) {
    throw entitiesListError;
  }

  const areMonitoredEntitiesExisting = entities.monitored.length > 0;
  const areRatedEntitiesExisting = entities.rated.length > 0;

  if (
    !isEntitiesListLoading &&
    !!entityName &&
    (areMonitoredEntitiesExisting || areRatedEntitiesExisting)
  ) {
    if (areMonitoredEntitiesExisting) {
      const entityValues = entities.monitored.map(entity => entity.value);
      const entityNameExists = entityValues.includes(entityName);

      if (entityNameExists) {
        return <>{children}</>;
      }
    }

    if (areRatedEntitiesExisting) {
      const entityValues = entities.rated.map(entity => entity.value);
      const entityNameExists = entityValues.includes(entityName);

      if (entityNameExists) {
        return <>{children}</>;
      }
    }

    return <Navigate to={ERoutes.DASHBOARD} replace />;
  }

  return null;
};
